import React from 'react'
import { BackButton } from './buttons/BackButton'
import { ShippingRateButton } from './buttons/ShippingRateButton'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { ShippingOptionsButton } from './buttons/ShippingOptionsButton'
import { useCheckoutContext } from './index'

export const TopActions = () => {
  const context = useCheckoutContext()
  const checkoutSteps = context?.checkoutSteps
  const [activePanel] = context.activePanel

  // const activePanel = useDataValue(activePanelData)
  // const checkoutSteps = useDataValue(checkoutStepsData)

  return (
    <HorizontalStack className="justify-content-between">
      {checkoutSteps?.map(({ topAction: TopAction, itemKey }) => (
        <React.Fragment key={itemKey}>
          <ShowIf condition={activePanel === itemKey}>{<TopAction />}</ShowIf>
        </React.Fragment>
      ))}
    </HorizontalStack>
  )
}

export const ItemTopActions = () => {
  const { canOrder, isBelowMinimumOrderAmount } = useCheckoutContext()

  return (
    <ShowIf condition={canOrder && !isBelowMinimumOrderAmount}>
      <ShippingOptionsButton />
    </ShowIf>
  )
}

export const ShippingOptionsTopActions = () => {
  return <ShippingRateButton />
}

export const ShippingRateTopActions = () => {
  const { components } = useCheckoutContext()

  return <components.paymentMethodButton />
}

export const PaymentMethodTopActions = () => {
  return <BackButton />
}
